export const RESEND_KE_WELCOME_EMAIL_MODAL_NAME =
  'RESEND_KE_WELCOME_EMAIL_MODAL_NAME';
